export default __webpack_public_path__ + "static/media/image-fallback-square.6ff7c7de.svg";